import React from "react";
import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { FaRegQuestionCircle } from "react-icons/fa";
import { RecoverySimulationItems } from "../../contexts/constants";
import { useTranslation } from "react-i18next";

// レベルに応じたインデント（px）を取得
const getLevelIndent = (level: number): number => {
  switch (level) {
    case 1: return 0;
    case 2: return 6;
    default: return 0;
  }
};

/**
 * 回収シミュレーションの項目説明ポップオーバー
 *
 * 使用例:
 * <RecoverySimulationExplanationPopover />
 */
interface RecoverySimulationExplanationPopoverProps {
  /** 簡易モードか（true時は営業利益・償却費の説明をサマリー由来の文言に変更） */
  isSimpleMode?: boolean;
}

export const RecoverySimulationExplanationPopover: React.FC<RecoverySimulationExplanationPopoverProps> = ({ isSimpleMode = false }) => {
  const { t } = useTranslation();
  const p = "features.InvestmentScreening.Popover.recoverySimulationExplanation.desc";
  const recoverySimulationExplanationData = [
    { symbol: "A", item: RecoverySimulationItems.capexAmount, description: t(`${p}.capexScreenInput`) },
    { symbol: "B", item: RecoverySimulationItems.recoveredResources, description: t(`${p}.recoveredResourcesFormula`) },
    { symbol: "C", item: RecoverySimulationItems.operatingProfit, description: isSimpleMode ? t(`${p}.simpleProfit`) : t(`${p}.plItem21`) },
    { symbol: "D", item: RecoverySimulationItems.equipmentDepreciation, description: isSimpleMode ? t(`${p}.simpleDepreciation`) : t(`${p}.plItem14`) },
    { symbol: "E", item: RecoverySimulationItems.uncollectedAmount, description: t(`${p}.uncollectedAmountFormula`) },
    { symbol: "F", item: RecoverySimulationItems.collectionPeriod, description: t(`${p}.collectionPeriodDesc`) },
  ];

  return (
    <Popover placement="right">
      <PopoverTrigger>
        <button style={{ background: 'none', border: 'none', padding: 0 }}>
          <FaRegQuestionCircle size="30px" cursor="pointer" />
        </button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent width="1000px" maxH="600px" overflowY="auto" bgColor="#fffff0">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader fontWeight="bold">{t('features.InvestmentScreening.Popover.recoverySimulationExplanation.title')}</PopoverHeader>
          <PopoverBody>
            <Table size="sm" variant="simple">
              <Thead>
                <Tr>
                  <Th w="60px">{t('common.label.symbol')}</Th>
                  <Th w="300px">{t('common.label.item')}</Th>
                  <Th>{t('common.label.description')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {recoverySimulationExplanationData.map((row, index) => (
                  <Tr key={index}>
                    <Td>{row.symbol}</Td>
                    <Td
                      fontWeight={row.item.level === 1 ? "bold" : "normal"}
                      pl={getLevelIndent(row.item.level)}
                    >
                      {row.item.name}
                    </Td>
                    <Td>{row.description}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};
